import { render, staticRenderFns } from "./alarmList.vue?vue&type=template&id=1942fcac&"
import script from "./alarmList.vue?vue&type=script&lang=js&"
export * from "./alarmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports